import http from '@/http';

const feedbackService = {
  // Lấy danh sách feedback với phân trang
  getFeedbackList(params = {}) {
    return http.get('/admin/feedback', { params });
  }
};

export default feedbackService;
